"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
exports.sandwichIds = {
    details: {
        consumptionReadingAlert: 'billing-details-consumptionReadingAlert-image',
        usageLinkImage: 'billing-details-dailyUsageLink-image',
        emptyState: 'billing-details-emptyState-image',
    },
    summary: {
        periodCards: {
            empty: 'billing-summaryPeriodCard-empty-image',
            current: 'billing-billing-summaryPeriodCard-empty-image-current-image',
            pending: 'billing-billing-summaryPeriodCard-empty-image-pending-image',
            historical: 'billing-billing-summaryPeriodCard-empty-image-historical-image',
        },
        error: 'billing-summary-error-image',
        noPeriods: 'billing-summary-noPeriods-image',
    },
};
